import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../../v2/style-helper/MediaQueries';

const useStyles = createUseStyles({
  comodo: {
    float: 'right',
    height: 85,
    [MediaQueries.phone]: {
      height: 50,
    },
  },
  logo: {
    display: 'block',
    height: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

export function Comodo() {
  const classes = useStyles();
  
  return (
    <div className={classes.comodo} data-test="Comodo">
      <a href="https://www.instantssl.com/ssl-certificate-products/multi-domain-ssl-certificate.html" target="_blank">
        <img
          className={classes.logo}
          data-test="Comodo__logo"
          src="https://ssl.comodo.com/images/comodo_secure_seal_100x85_transp.png"
          alt="Multi Domain SSL"
        />
      </a>
    </div>
  );
}

export default Comodo;
